module.exports = __webpack_public_path__ + "img/category-brand-hover.a1805930.png";